module.exports = __webpack_public_path__ + "static/icon-3855c7f4a5680ff6d12e4f461b043ee4.png";